import React, { useContext } from "react";
import { CombinedContext } from "../../../context/combinedContext";
import "./about.css";
import translations from "../../../translations/translations";


const About = () => {
	const { language } = useContext(CombinedContext);

	return (
		<div className="about-page">
			<div className="about-container">
				<h1 className="about-title">{translations[language].about.title}</h1>

				{/* Who We Are */}
				<section className="about-section">
					<h2>{translations[language].about.whoWeAre.title}</h2>
					<p>{translations[language].about.whoWeAre.text}</p>
				</section>

				{/* For Clients */}
				<section className="about-section">
					<h2>{translations[language].about.clients.title}</h2>
					<p>{translations[language].about.clients.text}</p>
				</section>

				{/* For Staff & Business Owners */}
				<section className="about-section">
					<h2>{translations[language].about.staff.title}</h2>
					<p>{translations[language].about.staff.text}</p>
				</section>

				{/* Mission */}
				<section className="about-section">
					<h2>{translations[language].about.mission.title}</h2>
					<p>{translations[language].about.mission.text}</p>
				</section>

				{/* Technology */}
				<section className="about-section">
					<h2>{translations[language].about.tech.title}</h2>
					<p>{translations[language].about.tech.text}</p>
				</section>

				{/* Future Vision */}
				<section className="about-section">
					<h2>{translations[language].about.future.title}</h2>
					<p>{translations[language].about.future.text}</p>
				</section>

				{/* Join Us */}
				<section className="about-section">
					<h2>{translations[language].about.joinUs.title}</h2>
					<p>{translations[language].about.joinUs.text}</p>
				</section>
			</div>
		</div>
	);
};

export default About;
